<div ngbAccordion #accordion="ngbAccordion" [closeOthers]="true" class="accordion" [attr.id]="refid">
  <ng-container *ngFor="let item of items; let id = index">
    <div ngbAccordionItem="{{ 'item' + id }}" class="border-2">
      <div ngbAccordionHeader class="justify-content-between accordion-nice-header">
        <div class="accordion-row-box">
          <div class="accordion-data-box ps-1">
            <div class="align-items-center w-100">
              <ng-content *ngTemplateOutlet="firstTemplate; context: { $implicit: item, index: id }"></ng-content>
            </div>
          </div>
          <div class="accordion-action-box">
            <div class="justify-content-around text-end weight-label">
              <button
                (click)="rowClick?.(item, id)"
                type="button"
                class="accordion-button accordion-nice-toggle"
                ngbAccordionButton>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-content *ngTemplateOutlet="secondTemplate; context: { $implicit: item, index: id }"></ng-content>
        </div>
      </div>
    </div>
  </ng-container>
</div>
